// extracted by mini-css-extract-plugin
export default {"someBar":"SeWGZ9T3dUKLKJe6OPUo-SocialMediaBar-someBar"};